const disputeClaimsFR = {
    "view": {
        "table": {
            "title": "Vos Violations de Droits d'Auteur",
            "columns": {
                "release": "Sortie",
                "user": "Utilisateur",
                "store": "Magasin",
                "claimantName": "Nom du Réclamant",
                "claimantEmail": "Email du Réclamant",
                "resolutionTime": "Temps de Résolution",
                "remainingTime": "Temps Restant",
                "status": "Statut"
            },
            "label": {
                "status_created": "Créé",
                "status_pending": "En Attente",
                "status_in_progress": "En Cours",
                "status_resolved": "Résolu",
                "status_copyright_violation": "Violation de Droits d'Auteur"
            },
            "button": {
                "exportCSV": "Exporter CSV"
            },
            "placeholder": {
                "search": "Recherche..."
            }
        }
    }
};

export default disputeClaimsFR;